import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const Section = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const Header = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(1),
  height: 24,
  width: "100%",
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(1),
}));
